const odSizeChart = document.getElementById('od-size-guide');
const odSizeChartOpenerList = document.querySelectorAll('.size-guide__opener');

if (odSizeChart) {
    odSizeChartOpenerList.forEach((opener) => {
        opener.addEventListener("click", () => {
            odSizeChart.classList.add("open");
            document.getElementById('product-drawer').classList.remove('open');
        });
    });

    odSizeChart.addEventListener("click", (event) => {
        if (!event.target.closest(".size-guide__content-wrapper") || event.target.closest(".close__modal")) {
            odSizeChart.classList.remove("open");
        }
    });

    odSizeChart.querySelectorAll(".sizing-chart__tab-handle").forEach((tabButton) => {
        tabButton.addEventListener("click", (event) => {
            const tabId = tabButton.querySelector('span').getAttribute('data-id');
            const allTabs = tabButton.closest('.tabs-container').querySelectorAll('.tab-content');
            const allTabButtons = tabButton.closest('.tabs-menu').querySelectorAll('.sizing-chart__tab-handle');

            const activeInnerTab = odSizeChart.querySelector('.tab-content.active .tab-content.active');
            if (activeInnerTab) {
                localStorage.setItem('activeInnerTab', activeInnerTab.getAttribute('id'));
            }

            allTabs.forEach((tab) => {
                tab.classList.remove('active');
            });

            const newActiveTab = odSizeChart.querySelector(`#${tabId}`);
            if (newActiveTab) {
                newActiveTab.classList.add('active');
            }

            allTabButtons.forEach((tab) => {
                tab.classList.remove('current');
            });

            tabButton.classList.add('current');

            const savedInnerTabId = localStorage.getItem('activeInnerTab');
            if (savedInnerTabId) {
                const savedInnerTab = newActiveTab.querySelector(`#${savedInnerTabId}`);
                if (savedInnerTab) {
                    newActiveTab.querySelectorAll('.tab-content').forEach((tab) => {
                        tab.classList.remove('active');
                    });
                    savedInnerTab.classList.add('active');
                }
            }

            odSizeChart.querySelectorAll('.tab-content.active .tabs-container--inner .dynamic__text--tab').forEach(activeTab => {
                const title = activeTab.closest('.tabs-container').querySelector('.tab-content.active .tab-content.active .tab-content__title');
                const dynamicText = activeTab.closest('.tabs-container').querySelector('.tabs-container--inner .dynamic__text--tab');

                if (title && dynamicText) {
                    dynamicText.innerHTML = title.innerHTML;
                }
            });
        });
    });



    odSizeChart.querySelectorAll('.tab-content.active .tabs-container--inner .dynamic__text--tab').forEach(activeTab => {
        const title = activeTab.closest('.tabs-container').querySelector('.tab-content.active .tab-content.active .tab-content__title');
        const dynamicText = activeTab.closest('.tabs-container').querySelector('.tabs-container--inner .dynamic__text--tab');

        if (title && dynamicText) {
            dynamicText.innerHTML = title.innerHTML;
        }
    });
}